import React from "react"
import "./Parcours.css"
import ParcoursApi from "./ParcoursApi"
import Card from "./Card"

const Parcours = () => {
  return (
    <>
      <section className='Resume' id='parcours'>
        <div className='container top'>
          <div className='heading text-center'>
            <h1>Mon parcours</h1>
          </div>

          <div className='content-section mtop d_flex'>
            <div className='left'>
              <div className='heading'>
                <h1>Mes Formations</h1>
              </div>

              <div className='content'>
                {ParcoursApi.map((val, id) => {
                  if (val.category === "formation") {
                    return <Card key={id} title={val.title} annee={val.annee} desc={val.desc} />
                  }
                })}

                {/*<div className='box btn_shadow'>
                  <div className='title_content d_flex'>
                    <div className='title'>
                      <h2>Personal Portfolio April Fools</h2>
                      <span>University of DVI (1997 - 2001)</span>
                    </div>
                    <div className='rate'>
                      <button className='btn_shadow '>4.30/5</button>
                    </div>
                  </div>
                  <hr />
                  <p> The education should be very interactual. Ut tincidunt est ac dolor aliquam sodales. Phasellus sed mauris hendrerit, laoreet sem in, lobortis mauris hendrerit ante.</p>
                </div>*/}
              </div>
            </div>
            <div className='left'>
              <div className='heading'>
                <h1> Mes Expriences</h1>
              </div>

              <div className='content'>
                {ParcoursApi.map((val, index) => {
                  if (val.category === "exprience") {
                    return <Card key={index} title={val.title} annee={val.annee} desc={val.desc} />
                  }
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Parcours